import { inject, Injectable } from '@angular/core';
import { StrapiApiResponse } from '../models/strapi.models';
import { ContentGateway } from './content-gateway';

@Injectable({
  providedIn: 'root',
})
export class StrapiService {
  private _content = inject(ContentGateway);

  getPosts(categoryId?: string) {
    return this._content.fetch<StrapiApiResponse>({ kind: 'posts', category: categoryId });
  }

  getCategories() {
    return this._content.fetch<any>({ kind: 'categories' });
  }

  getPostBySlug(slug: string) {
    return this._content.fetch<StrapiApiResponse>({ kind: 'post', slug });
  }

  getPrivacyPolicy() {
    return this._content.fetch<any>({ kind: 'legal', document: 'privacy-policy' });
  }

  getTermsOfUse() {
    return this._content.fetch<any>({ kind: 'legal', document: 'terms-of-service' });
  }
}
